import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-2 mt-2 lg:mt-0 rounded shadow bg-white" }
const _hoisted_2 = { class: "p-6" }
const _hoisted_3 = { class: "text-xl font-bold" }
const _hoisted_4 = { class: "pt-2 text-gray-600 text-xs lg:text-sm flex items-center justify-center lg:justify-start" }
const _hoisted_5 = { class: "pt-2 text-gray-600 text-xs lg:text-sm flex items-center justify-center lg:justify-start" }
const _hoisted_6 = { class: "pt-2 text-gray-600 text-xs lg:text-sm flex items-center justify-center lg:justify-start" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, " 【" + _toDisplayString(_ctx.dealer.id ?? "") + "】" + _toDisplayString(_ctx.dealer.name ?? "") + " (" + _toDisplayString(_ctx.dealer.kana ?? "") + ") ", 1),
      _createElementVNode("p", _hoisted_4, [
        _createElementVNode("span", null, [
          _createVNode(_component_fa, {
            icon: "map-marked-alt",
            class: "text-sm text-color-3 mr-2"
          })
        ]),
        _createTextVNode(" " + _toDisplayString(`${_ctx.dealer.prefecture ?? ""}${_ctx.dealer.city ?? ""}${_ctx.dealer.address ?? ""}${
            _ctx.dealer.building || ""
          }`), 1)
      ]),
      _createElementVNode("p", _hoisted_5, [
        _createElementVNode("span", null, [
          _createVNode(_component_fa, {
            icon: "phone",
            class: "text-sm text-color-3 mr-2"
          })
        ]),
        _createTextVNode(" " + _toDisplayString(_ctx.dealer.telephone ?? ""), 1)
      ]),
      _createElementVNode("p", _hoisted_6, [
        _createElementVNode("span", null, [
          _createVNode(_component_fa, {
            icon: "university",
            class: "text-sm text-color-3 mr-2"
          })
        ]),
        _createTextVNode(" " + _toDisplayString(_ctx.dealer.bank_name ?? "") + " " + _toDisplayString(_ctx.dealer.branch_name ?? ""), 1),
        _hoisted_7,
        _createTextVNode(" " + _toDisplayString(_ctx.formatAccountType(_ctx.dealer.account_type)) + " " + _toDisplayString(_ctx.dealer.account_no ?? "") + " " + _toDisplayString(_ctx.dealer.account_name ?? ""), 1)
      ])
    ])
  ]))
}